"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridHeadItem = _interopRequireDefault(require("./GridHeadItem"));

var _GridPopup = _interopRequireDefault(require("./GridPopup"));

var _gridConfig = require("./gridConfig");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialDnD = {
  dragged: {},
  draggedOver: {},
  dragCanDrop: true
};

var GridHead = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GridHead, _React$PureComponent);

  var _super = _createSuper(GridHead);

  function GridHead() {
    var _this;

    _classCallCheck(this, GridHead);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, initialDnD));

    _defineProperty(_assertThisInitialized(_this), "handleSaveChangeHiddenColumn", function (fields) {
      _this.props.params.onChangeFields(fields); // this.restartHeaderResizeObserver();

    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (event) {
      var params = _this.props.params;

      var columnName = _this.getColumnName(event, 'onDragStart');

      if (!params.fields[columnName].noDnD) {
        _this.setState({
          dragged: _this.getByColumnName(columnName)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnter", function (event) {
      var _this$state = _this.state,
          dragged = _this$state.dragged,
          currentDraggedOver = _this$state.draggedOver; // dragging NOT a th, so do nothing

      if (!dragged.columnName) return;

      var columnName = _this.getColumnName(event, 'onDragEnter');

      if (currentDraggedOver.columnName && columnName === currentDraggedOver.columnName) {
        return;
      }

      var draggedOver = _this.getByColumnName(columnName);

      var dragCanDrop = _this.handleDragCanDrop(draggedOver);

      _this.setState({
        draggedOver: draggedOver,
        dragCanDrop: dragCanDrop
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getColumnName", function (event, handler) {
      var target = _this.getClosestTh(event);

      var columnName = target.dataset.name;

      if (!columnName) {
        console.warn('current target is', target);
        throw new Error("target must have data-name in ".concat(handler, " handler, data-name is ").concat(columnName));
      }

      return columnName;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragCanDrop", function (draggedOver) {
      var dragged = _this.state.dragged;
      var thDnD = _this.props.params.thDnD;

      if (thDnD && thDnD.canDrop) {
        return thDnD.canDrop(dragged, draggedOver);
      }

      return dragged.columnName !== draggedOver.columnName;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (event) {
      event.persist();

      if (event.preventDefault) {
        event.preventDefault(); // Necessary. Allows us to drop.
      }

      var dragCanDrop = _this.state.dragCanDrop;
      event.dataTransfer.dropEffect = dragCanDrop ? 'move' : 'none';
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function () {
      var _this$state2 = _this.state,
          dragged = _this$state2.dragged,
          draggedOver = _this$state2.draggedOver,
          dragCanDrop = _this$state2.dragCanDrop;

      if (dragCanDrop) {
        var _this$props$params = _this.props.params,
            fields = _this$props$params.fields,
            onChangeFields = _this$props$params.onChangeFields;
        var fieldsKeys = Object.keys(fields);
        var fromIndex = fieldsKeys.findIndex(function (key) {
          return key === dragged.columnName;
        });
        var toIndex = fieldsKeys.findIndex(function (key) {
          return key === draggedOver.columnName;
        });

        if (fromIndex !== toIndex) {
          var movedItem = fieldsKeys.splice(fromIndex, 1)[0];
          fieldsKeys.splice(toIndex, 0, movedItem);
          var newFields = fieldsKeys.reduce(function (acc, key) {
            acc[key] = fields[key];
            return acc;
          }, {});
          onChangeFields(newFields);
        }
      }

      _this.setState(initialDnD);
    });

    _defineProperty(_assertThisInitialized(_this), "getClosestTh", function (event) {
      return event.target.tagName === 'TH' ? event.target : event.target.closest('th');
    });

    _defineProperty(_assertThisInitialized(_this), "getByColumnName", function (name) {
      return _objectSpread(_objectSpread({}, _this.props.params.fields[name]), {}, {
        columnName: name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSort", function (field, item) {
      var _this$props = _this.props,
          _this$props$sort = _this$props.sort,
          handleSort = _this$props$sort.handleSort,
          order = _this$props$sort.order,
          sortedField = _this$props$sort.field,
          data = _this$props.data;
      if (item.noSorted) return;
      if (!data || !data.length) return;
      if (field !== sortedField) return handleSort({
        field: field,
        order: _gridConfig.ASC
      });
      return handleSort({
        field: field,
        order: !order ? _gridConfig.ASC : order === _gridConfig.ASC ? _gridConfig.DESC : ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMaximaze", function (columnName) {
      var _this$props$params2 = _this.props.params,
          onChangeFields = _this$props$params2.onChangeFields,
          fields = _this$props$params2.fields;

      var newFields = _objectSpread({}, fields); // TODO FIX MUTATION


      newFields[columnName].classWidth = String(_gridConfig.CLASS_WIDTHS_SET.length - 1);
      onChangeFields(newFields);
    });

    return _this;
  }

  _createClass(GridHead, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          params = _this$props2.params,
          groups = _this$props2.groups,
          sort = _this$props2.sort,
          lastField = _this$props2.lastField,
          resizedColumnName = _this$props2.resizedColumnName,
          handleStartResize = _this$props2.handleStartResize,
          forceWidth = _this$props2.forceWidth,
          fixedWidths = _this$props2.fixedWidths,
          columnsMenu = _this$props2.columnsMenu,
          gridId = _this$props2.gridId;
      var draggedOver = this.state.draggedOver;
      var withoutColumnsMenu = params.options.withoutColumnsMenu;
      return /*#__PURE__*/_react["default"].createElement("table", {
        className: "table-grid grid-fixed-header",
        cellSpacing: "0"
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, groups && /*#__PURE__*/_react["default"].createElement("th", {
        className: "grid-cell-checkbox",
        "data-name": "_checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        disabled: true
      })), Object.keys(params.fields).map(function (field, key) {
        return /*#__PURE__*/_react["default"].createElement(_GridHeadItem["default"], {
          key: field || key,
          field: field,
          lastField: lastField,
          item: params.fields[field],
          t: params.t,
          sort: sort,
          onDragStart: _this2.handleDragStart,
          onDragEnter: _this2.handleDragEnter,
          onDragOver: _this2.handleDragOver,
          onDragEnd: _this2.handleDragEnd,
          dropHighlight: field === draggedOver.columnName,
          onStartResize: handleStartResize,
          forceWidth: field === resizedColumnName ? forceWidth : null,
          fixedWidth: fixedWidths ? fixedWidths[field] : null,
          resizing: !!resizedColumnName,
          onSort: _this2.handleSort,
          onMaximaze: _this2.handleMaximaze
        });
      }), !withoutColumnsMenu && /*#__PURE__*/_react["default"].createElement("th", {
        className: "grid-cell-hidemenu",
        "data-name": "columns-hide-menu"
      }, /*#__PURE__*/_react["default"].createElement(_GridPopup["default"], {
        t: params.t,
        fields: params.fields,
        columnsMenu: columnsMenu,
        handleSaveChanges: this.handleSaveChangeHiddenColumn,
        gridId: gridId
      })))));
    }
  }]);

  return GridHead;
}(_react["default"].PureComponent);

GridHead.propTypes = {
  data: _propTypes["default"].array,
  params: _propTypes["default"].object,
  groups: _propTypes["default"].object,
  sort: _propTypes["default"].object,
  lastField: _propTypes["default"].string,
  fixedWidths: _propTypes["default"].object,
  resizedColumnName: _propTypes["default"].string,
  forceWidth: _propTypes["default"].number,
  handleStartResize: _propTypes["default"].func,
  columnsMenu: _propTypes["default"].object,
  gridId: _propTypes["default"].number
};
GridHead.defaultProps = {
  data: [],
  params: {},
  sort: {}
};
var _default = GridHead;
exports["default"] = _default;